import { createApp } from 'vue';
const app = createApp({
 // root instance definition 
});
import * as bootstrap from 'bootstrap';
import SearchComponent from './components/SearchComponent.vue';
import ModalComponent from './components/ModalComponent.vue';
app.component('search-component', SearchComponent);
app.component('modal-component', ModalComponent);
app.mount("#app");

// Application bootstrapping
window._      = require('lodash');
window.Popper = require('popper.js').default;
window.$      = window.jQuery = require('jquery');
window.axios  = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.bootstrap = require('bootstrap');
// vendor dependencies
require('bootstrap');

// DataTables
require('jszip/dist/jszip');
require('datatables.net-bs5');
require('datatables.net-buttons-bs5');
require('datatables.net-buttons/js/buttons.colVis.js');
require('datatables.net-buttons/js/buttons.html5.js');
require('datatables.net-fixedheader-bs5');
require('datatables.net-responsive-bs5');
require('datatables.net-select-bs5');

// momentjs
window.moment = require('moment');

// toastr
window.toastr = require('toastr');
window.toastr.options = {
    "preventDuplicates": true,
    "preventOpenDuplicates": true
};

// flash
window.flash = require('./utilities/flash');

// flatpickr (date/time picker)
require('flatpickr');

// Sweetalert2
let swal = require('sweetalert2');

window.swal = swal.mixin({
    customClass: {
      confirmButton: 'btn btn-primary',
      cancelButton: 'btn btn-link'
    },
    buttonsStyling: false,
  })
// JS utilities
$(document).ready(function () {
    require('./utilities/ajax');
    require('./utilities/datatables');
    require('./utilities/forms');
    require('./utilities/mask');
    require('./utilities/modal');
    require('./utilities/nav-toggle');
});

require('./footer_ie_message.js');
